import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function PainSection() {
  const painPoints = ['Intentás conectar con tu hijo pero a veces sentís que hablan idiomas distintos', 'Reaccionás de una forma que no querías y la culpa no te deja dormir', 'Probás técnicas de crianza que funcionan con otros niños pero con el tuyo no', 'No entendés por qué tu hijo reacciona tan diferente ante situaciones cotidianas', 'Te agotás emocionalmente sin saber exactamente qué es lo que él necesita de vos'];
  return <section className="py-10 px-4 bg-white relative" data-id="element-162">
      {/* Subtle top divider */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-px bg-gold-300/50" data-id="element-163"></div>

      <div className="max-w-3xl mx-auto" data-id="element-164">
        <FadeIn data-id="element-165">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-burgundy-900 mb-12" data-id="element-166">
            ¿Te sentís identificada con alguna de estas situaciones?
          </h2>
        </FadeIn>

        <div className="space-y-6 mb-12" data-id="element-167">
          {painPoints.map((point, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-168">
              <div className="flex items-start p-6 bg-dusty-rose-50 rounded-2xl border-2 border-dusty-rose-200 shadow-md" data-id="element-169">
                <span className="text-2xl mr-4 flex-shrink-0" data-id="element-170">😔</span>
                <p className="text-lg text-burgundy-800 leading-relaxed" data-id="element-171">
                  {point}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-172">
          <p className="text-center text-xl font-heading italic text-burgundy-700" data-id="element-173">
            Si dijiste que sí a alguna de estas — este sistema fue creado
            exactamente para vos.
          </p>
        </FadeIn>
      </div>
    </section>;
}